import DisabilityClaimsDetails from 'components/HolisticPayroll/DisabilityClaimsDetails'

const View = (props) => <DisabilityClaimsDetails {...props} />

export default View
